// assets
import {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  SendOutlined
} from '@ant-design/icons';

// icons
const icons = {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  SendOutlined
};

// ==============================|| MENU ITEMS - BASE DE DATOS ||============================== //

const pages = {
  id: 'base-datos',
  title: 'Base de Datos',
  type: 'group',
  children: [
    
    {
      id: 'bancos',
      title: 'Cuentas Bancarias',
      type: 'item',
      url: '/bancos',
      icon: icons.SendOutlined
    }
  ]
};

export default pages;
